import { render, staticRenderFns } from "./VuesticIconFree.vue?vue&type=template&id=d26ecaa4"
import script from "./VuesticIconFree.vue?vue&type=script&lang=js"
export * from "./VuesticIconFree.vue?vue&type=script&lang=js"
import style0 from "./VuesticIconFree.vue?vue&type=style&index=0&id=d26ecaa4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d26ecaa4')) {
      api.createRecord('d26ecaa4', component.options)
    } else {
      api.reload('d26ecaa4', component.options)
    }
    module.hot.accept("./VuesticIconFree.vue?vue&type=template&id=d26ecaa4", function () {
      api.rerender('d26ecaa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-icon/VuesticIconFree.vue"
export default component.exports